import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Items from "@/pages/Items";
import ItemDetail from "@/pages/ItemDetail";
import Locations from "@/pages/Locations";
import Categories from "@/pages/Categories";
import Search from "@/pages/Search";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import Household from "@/pages/Household";
import Profile from "@/pages/Profile";
import PublicLocation from "@/pages/PublicLocation";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
// Marketing pages
import Landing from "@/pages/marketing/Landing";
import Features from "@/pages/marketing/Features";
import About from "@/pages/marketing/About";
import Contact from "@/pages/marketing/Contact";
import FAQ from "@/pages/marketing/FAQ";
import Privacy from "@/pages/marketing/Privacy";
import Terms from "@/pages/marketing/Terms";
import Blog from "@/pages/marketing/Blog";
import BlogPost from "@/pages/marketing/BlogPost";
import BlogAdmin from "@/pages/marketing/BlogAdmin";
import DeleteAccount from "@/pages/marketing/DeleteAccount";
import BetaTesting from "@/pages/marketing/BetaTesting";
import TryDemo from "@/pages/marketing/TryDemo";
import Download from "@/pages/marketing/Download";
import BetaAdmin from "@/pages/admin/BetaAdmin";
import UsersAdmin from "@/pages/admin/UsersAdmin";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public marketing */}
            <Route path="/" element={<Home />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/features" element={<Features />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/beta" element={<BetaTesting />} />
            <Route path="/try-demo" element={<TryDemo />} />
            <Route path="/download" element={<Download />} />
            <Route path="/get-the-app" element={<Download />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/pricing" element={<Pricing />} />

            {/* Auth & invites */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route path="/p/loc/:token" element={<PublicLocation />} />

            {/* App (authed) */}
            <Route path="/items" element={<Protected><Items /></Protected>} />
            <Route path="/items/:id" element={<Protected><ItemDetail /></Protected>} />
            <Route path="/locations" element={<Protected><Locations /></Protected>} />
            <Route path="/categories" element={<Protected><Categories /></Protected>} />
            <Route path="/search" element={<Protected><Search /></Protected>} />
            <Route path="/billing/success" element={<Protected><BillingSuccess /></Protected>} />
            <Route path="/household" element={<Protected><Household /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />

            {/* Admin */}
            <Route path="/admin/blog" element={<ProtectedRoute><BlogAdmin /></ProtectedRoute>} />
            <Route path="/admin/beta" element={<ProtectedRoute><BetaAdmin /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute><UsersAdmin /></ProtectedRoute>} />

            {/* Landing fallback */}
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
